import styled from "styled-components";

export const HeaderWrapper = styled.header`
  background: white;
  border-bottom: 2px solid #c2185b;
  padding: 10px 10px 10px 10px;
  font-family: TeleNeo Var;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1000;
  @media (max-width: 1024px) {
    padding-left:5px;
  }
  @media (max-width: 390) {
    padding-left:12px;
  }  
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  grid-template-columns: 1fr;
  gap: 1rem;
  margin-left: 2.5rem;
  margin-right: 2.5rem;
  max-width: none;

  @media (max-width: 1024px) {
    margin-left: 0;
    margin-right: 0;
  }
`;

export const Logo = styled.div`
  img {
    height: 85px;

    @media (max-width: 768px) {
    height: 38px;
  }
  }

`;



export const JoinButton = styled.div`
  button {
    background-color: #E20874;
    color: white;
    border: none;
    padding: 18px 36px;
    border-radius: 4px;
    font-weight: 700;
    font-size: 28px;
    cursor: pointer;
    border-radius: 12px;
    margin-left: 3rem;

    &:hover {
      background-color:rgb(211, 5, 108);
      transform: scale(1.05);
      
    }

    @media(max-width: 768px){
     padding: 4px 8px;
     font-size: 12px;
     border-radius: 2.54px;
     height: 32px;
     margin-left: 0rem;
  }
    @media(max-width: 1024px){
     margin-left: 0rem;
  }
  }

  
`;

export const Hamburger = styled.button`
  display: none;
  font-size: 26px;
  background: none;
  border: none;
  cursor: pointer;
  color: #c2185b;
  padding: 0px;

  @media (max-width: 1024px) {
    display: block;
    font-size: 38px;
  }
`;

export const NavLinks = styled.nav`
  display: flex;
  gap: 2rem;
  margin-left: auto; 

  a {
    font-size: 1.25rem;
    text-decoration: none;
    color: var(--Color-3, #0E0F11);
    font-weight: 700;
    

    &.active {
      color: #e20074;
    }

    &:hover {
      color: #e20074;
      transform: scale(1.05); 
    }
  }

  @media (max-width: 1024px) {
    display: none;

    &.active {
      display: flex;
      flex-direction: column;
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: white;
      z-index: 9999;
      padding: 3rem 2rem 2rem;
      animation: slideIn 0.3s ease forwards;
    }

    a {
      font-size: 1.2rem;
      margin: 1.2rem 0;
      
    }

    .close-icon {
      position: absolute;
      top: 1.2rem;
      right: 1.5rem;
      font-size: 2rem;
      cursor: pointer;
      display: block;
    }
  }

  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0%);
    }
  }
`;


